import { Component, computed, signal, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { Toaster } from '../toaster/toaster';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, Toaster],
  template: `
    <div class="m-layout">
      <app-sidebar [userName]="userName()" [userEmail]="userEmail()" (logout)="handleLogout()" />

      <div class="m-layout__main">
        <app-header
          [title]="pageTitle()"
          [showSaveButton]="showSaveButton()"
          (save)="handleSave()"
        />

        <main class="m-layout__content">
          <div class="m-layout__contentInner">
            <router-outlet />
          </div>
        </main>
      </div>

      <app-toaster />
    </div>
  `,
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly authService = inject(AuthenticationService);
  private readonly currentRoute = signal<string>('/global');

  userName = computed(() => this.authService.getUserGivenName());
  userEmail = computed(() => this.authService.getUserEmail());

  pageTitle = computed(() => {
    const route = this.currentRoute();
    const translate = this.translate;

    if (route.includes('/global')) return translate.instant('SIDEBAR.GLOBAL');
    if (route.includes('/evaluation')) return translate.instant('SIDEBAR.EVALUATION');
    if (route.includes('/enseignes')) return translate.instant('SIDEBAR.ENSEIGNES');
    if (route.includes('/nexpe')) return translate.instant('SIDEBAR.NEXPE');
    if (route.includes('/nouveautes')) return translate.instant('SIDEBAR.NOUVEAUTES');
    if (route.includes('/utilisateurs')) return translate.instant('SIDEBAR.UTILISATEURS');
    return 'Configuration';
  });

  showSaveButton = computed(() => {
    const route = this.currentRoute();
    // Ne pas afficher le bouton pour les pages enseignes, nexpe && nouveautes
    return (
      !route.includes('/enseignes') &&
      !route.includes('/nexpe') &&
      !route.includes('/nouveautes') &&
      !route.includes('/utilisateurs')
    );
  });

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute.set(event.url);
      });
  }

  handleSave(): void {
    const route = this.currentRoute();
    //TODO: remove dispatchEvent and use a specific store with signal instead
    // Emit a custom event that child components can listen to
    window.dispatchEvent(new CustomEvent('global-save-triggered', { detail: { route } }));
  }

  handleLogout(): void {
    this.authService.logout();
  }
}
